import "react-toastify/dist/ReactToastify.css";

import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Splash from "./components/Splash";
import { attendanceDomain } from "./domain";
import { Auth } from "./domain_v2/auth";
import { CustomModal } from "./modal";
import { DetailedStudentListPage, LoginPage, MainPage } from "./pages";
import { ROUTE_NAME } from "./RouteName";

const App = () => {
  React.useEffect(() => {
    attendanceDomain.initIsViewStudentList();
  }, []);

  if (Auth.authService.isInitializing) {
    return <Splash />;
  }

  return (
    <Suspense fallback={<></>}>
      <div className="app">
        <Routes>
          <Route path={ROUTE_NAME.ROOT} element={<LoginPage />} />
          <Route path={ROUTE_NAME.LOGIN} element={<LoginPage />} />
          {Auth.authService.isTokenValid && (
            <>
              <Route path={ROUTE_NAME.MAIN} element={<MainPage />} />
              <Route
                path={ROUTE_NAME.STUDENT_LIST}
                element={<DetailedStudentListPage />}
              />
            </>
          )}
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar
        theme="dark"
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
      <CustomModal />
    </Suspense>
  );
};

export default observer(App);
